import classNames from "classnames";
import React, { ButtonHTMLAttributes, HTMLAttributes } from "react";

import { ButtonGroupButton, ButtonGroupWrapper, StyledButtonGroup } from "./ButtonGroup.styled";

export type ButtonGroupProps = HTMLAttributes<HTMLDivElement> & {
  /**
   * Set button variant
   *
   * @type {"primary" | "mini"}
   */
  variant: "primary" | "mini";

  /**
   * Set border radius
   *
   * @type {number}
   * @default {4}
   */
  borderRadius?: number;
};

export type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  active: boolean;
};

const defaultProps = {
  variant: "primary"
};

const ButtonGroupComp = React.forwardRef<HTMLDivElement, ButtonGroupProps>((props, ref) => {
  const { children, className, variant, borderRadius, ...restProps } = props;
  const buttonClass = classNames("c-button-group", className);

  function renderOneButton(
    { children, active, disabled, ...restChildProps }: ButtonGroupProps & ButtonProps,
    index?: number
  ) {
    return (
      <StyledButtonGroup
        data-testid="qa-button-group"
        key={index}
        active={active}
        disabled={disabled}
        variant={variant}
        borderRadius={borderRadius}
        {...restChildProps}
      >
        {children}
      </StyledButtonGroup>
    );
  }

  function renderButtons() {
    if (Array.isArray(children)) {
      return children.map((child, index) => renderOneButton(child.props, index));
    }
    return renderOneButton((children as any).props);
  }

  return (
    <ButtonGroupWrapper data-testid="qa-button-group-wrapper" ref={ref} className={buttonClass} {...restProps}>
      {renderButtons()}
    </ButtonGroupWrapper>
  );
});

const ButtonGroup = Object.assign(ButtonGroupComp, {
  defaultProps,
  Button: ButtonGroupButton
});

export default ButtonGroup;
